<template>
  <main-layout>
    <h1 class="title">Ricerca corsi</h1>

    <b-field horizontal grouped label="Data (da/a)">
      <datepicker v-model="dateRangeAfter"></datepicker>
      <datepicker v-model="dateRangeBefore"></datepicker>
    </b-field>
    <b-field horizontal label="Corso associato">
      <b-select v-if="courseTypes" v-model="selectedCourseType">
        <option :value="null"></option>
        <option
          v-for="courseType in courseTypes.results"
          :key="courseType.id"
          :value="courseType.id"
        >
          {{ courseType.code }}
        </option>
      </b-select>
    </b-field>

    <b-field grouped horizontal style="margin-bottom: 30px">
      <p class="control">
        <button
          class="button is-success"
          style="margin-right: 15px"
          @click="fetch()"
        >
          Cerca
        </button>
        <button class="button" @click="clean()">Pulisci</button>
      </p>
    </b-field>

    <div style="position: relative; min-height: 400px">
      <b-table
        v-if="results && results.length > 0"
        striped
        :data="results"
        :total="results.count"
        backend-sorting
        :default-sort="['id', 'desc']"
        @sort="onSort"
      >
        <template slot-scope="props">
          <b-table-column
            field="customer_internal_id"
            label="ID cliente"
            width="40"
            sortable
            numeric
          >
            {{ props.row.customer_internal_id }}
          </b-table-column>

          <b-table-column field="customer_name" label="Cliente" sortable>
            <b>
              <router-link
                :to="{
                  name: 'customers.show',
                  params: { id: props.row.customer }
                }"
              >
                {{ props.row.customer_name }}
              </router-link>
            </b>
          </b-table-column>

          <b-table-column field="type_name" label="Corso" sortable>
            {{ props.row.type_name }}
          </b-table-column>

          <b-table-column field="date" label="Data" sortable>
            {{ props.row.date }}
          </b-table-column>

          <b-table-column field="notes" label="Note" sortable>
            {{ props.row.notes }}
          </b-table-column>
        </template>
        <template slot="footer">
          <download-csv
            class="button is-default"
            :data="results"
            name="data.csv"
            delimiter=";"
          >
            <b-icon icon="table"></b-icon>
            <span>CSV</span>
          </download-csv>
        </template>
      </b-table>
      <b-loading :is-full-page="false" :active.sync="loading"></b-loading>
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"

import MainLayout from "@/layouts/Main"
import CourseContractProxy from "@/proxies/CourseContractProxy"

export default {
  name: "CourseContractsIndex",
  components: {
    MainLayout
  },
  data() {
    return {
      loading: false,
      results: null,
      sortField: "id",
      sortOrder: "desc",
      dateRangeAfter: null,
      dateRangeBefore: null,
      selectedCourseType: null,
      selectedContractCategory: null
    }
  },
  computed: {
    courseTypes: get("courseTypes/courseTypes")
  },
  mounted() {
    this.fetchCourseTypes()
  },
  methods: {
    fetchCourseTypes: call("courseTypes/all"),
    async fetch() {
      this.loading = true
      let params = {
        ordering: `${this.sortOrder == "desc" ? "-" : ""}${this.sortField}`
      }

      if (this.dateRangeAfter && this.dateRangeBefore) {
        params.date_range_after = this.fixDate(this.dateRangeAfter)
        params.date_range_before = this.fixDate(this.dateRangeBefore)
      }

      if (this.selectedCourseType) {
        params.type = this.selectedCourseType
      }

      this.results = await new CourseContractProxy(params).all()

      if (this.results.length === 0) {
        this.results = null
        this.$toast.open({
          message: "Nessun risultato trovato",
          type: "is-warning"
        })
      }

      this.loading = false
    },
    clean() {
      this.dateRangeAfter = null
      this.dateRangeBefore = null
      this.selectedCourseType = null
      this.results = null
    },
    fixDate(date) {
      return this.$moment(date).format("YYYY-MM-DD")
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.fetch()
    }
  }
}
</script>
